module.exports = __webpack_public_path__ + "static/img/meter_5.d08f01c1.gif";